export const LICENSE_ERRORS = {
  LIMIT_REACHED: "License limit reached",
};
